import { css, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { Style } from "../Styles";
import { BaseElement } from "../BaseElement";
import * as AppSyncSchema from "../../AppSyncSchema";
import { DiffOperation, makeDiffControl } from "./Controls";
import { ModelField } from "@aws-amplify/datastore";
import { litIf } from "../LitUtils";

@customElement("ds-diff-control")
export class DiffControl extends BaseElement {
    static override styles = [
        Style,
        css`
            :host {
                display: block;
            }

            .accept-reject {
                justify-content: end;
            }

            .header {
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
        `,
    ];
    @property({ type: String }) heading?: string;
    @property({ type: Object }) field?: ModelField;
    @property({ type: String }) op?: DiffOperation;
    @property({ type: Object }) value?: any;
    @property({ type: Boolean }) noAcceptReject = false;

    @state() protected _accepted?: boolean;

    private _accept() {
        if (this._accepted === true) {
            this._accepted = undefined;
            this._raiseEvent("ds-reject-diff");
        } else {
            this._accepted = true;
            this._raiseEvent("ds-accept-diff");
        }
    }

    private _reject() {
        if (this._accepted === false) {
            this._accepted = undefined;
        } else {
            this._accepted = false;
            this._raiseEvent("ds-reject-diff");
        }
    }

    override render() {
        if (this.heading && this.field && this.op && this.value) {
            let acceptVariant = "default";
            let rejectVariant = "default";

            if (this._accepted === true) {
                acceptVariant = "success";
            } else if (this._accepted == false) {
                rejectVariant = "danger";
            }

            return html`<div class="flex-column">
                <div class="header">
                    <h4>${this.heading}</h4>
                    <div class="accept-reject flex-row">
                        ${litIf(
                            !this.noAcceptReject,
                            () => html`
                                <sl-button
                                    @click=${() => this._accept()}
                                    size="small"
                                    variant=${acceptVariant}
                                    >Accept</sl-button
                                >
                                <sl-button
                                    @click=${() => this._reject()}
                                    size="small"
                                    variant=${rejectVariant}
                                    >Reject</sl-button
                                >
                            `
                        )}
                    </div>
                </div>
                ${makeDiffControl(AppSyncSchema.getTypeName(this.field), this.op, this.value)}
            </div>`;
        }
        return html``;
    }
}
declare global {
    interface HTMLElementTagNameMap {
        "ds-diff-control": DiffControl;
    }
}
